import React, { useEffect, useState, useCallback } from "react";
import {
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  Image,
  Dimensions,
} from "react-native";
import { ProgressBar } from "react-native-paper";
import { AppColors } from "../../../../../utility/AppColors";
import Ionicons from "@expo/vector-icons/Ionicons";
import {
  base_url,
  endpoints,
  NotificationType,
} from "../../../../../Api/configs";
import { toast } from "react-toastify";
import { ShowLoader } from "../../../../../common/ShowLoader";
import { chatUrl, formatDate } from "../../../../../utility/Index";
import { AppImages } from "../../../../../utility/AppImages";
import {
  CommonActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../../../utility/NavigationHelper";
import { AppScreens } from "../../../../Utility/AppScreens";
import { useNotificationDetailsPopupStyles } from "./notificationDetailsPopupStyles";
import withErrorBoundary from "../../../../../utility/auth/withErrorBoundary";
import NotificationHeaderSkeleton from "../../../../../Components/skeleton-components/NotificationHeaderSkeleton";
import Skeletons from "../../../../../Components/skeleton-components/Skeletons";
import NotificationDetailsRowSkeleton from "../../../../../Components/skeleton-components/NotificationDetailsRowSkeleton";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { Base64 } from "js-base64";
import ImageComponent from "../../../../../Components/ImageComponent";
import { AppFontStyle } from "../../../../../styles/AppFontStyle";
import { format, isValid } from "date-fns";
import { ImageSourcePropType } from "react-native";
import { useNotifications } from "../../../../../context/NotificationContext";
import ChallengeAcceptModal from "./ChallengeAcceptModal";
import { fetchUserConnectionStatus } from "../../../../../services/stream";
import { Badge } from "../../../../../Components/notification-common-components/Badge";
import { CropImage } from "../../../../../Components/choose-avatar-components/CropImage";
import { getNotificationById } from "../../../../../services/notification";
import CornfirmPurchaseBeltModal from "../../BeltScreens/CornfirmPurchaseBeltModal";
import {
  fetchPaymentBeltExchange,
  fetchUserBalance,
} from "../../../../../services/profileAPI";
import { handleApiError } from "../../../../../services/errorHandler";
import BeltPurchaseSuccessModal from "../../BeltScreens/BeltPurchaseSuccessModal";
import Avatar from "../../../../../Components/choose-avatar-components/Avatar";
import {
  getStoredEventShareAction,
  clearStoredEventShareAction,
  storeEventShareAction,
  storePendingChallengeAccept,
} from "../../../../../utility/urlUtils";
import { useUserData } from "../../../../../context/UserDataContext";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../../../services/activityService";

interface NotificationDetailsProps {
  showModal?: boolean;
  setShowModal: (show: boolean) => void;
  onAcceptPress: (accepted: boolean) => void;
  challengeID: string;
  accessToken: string;
  username: string;
}

export function NotificationDetails(props: NotificationDetailsProps) {
  const {
    showModal = false,
    setShowModal,
    onAcceptPress,
    challengeID,
    accessToken,
    username,
  } = props;
  const deviceSize = useDeviceSize();
  const [showCreateLoader, setCreateShowLoader] = useState(false);
  const [showAcceptLoader, setAcceptLoader] = useState(false);
  const [challengeDetails, setChallengeDetails] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [numberOfBelts, setNumberOfBelts] = useState("0");
  const [insufficientStakesError, setInsufficientStakesError] = useState(null);
  const [storedAction, setStoredAction] = useState(null);
  const [userTokenBalance, setUserTokenBalance] = useState(0);
  const [arrBeltMedalType, setArrBeltMedalType] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      purchasedBeltAmount: 0,
      width:
        deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
          ? 69
          : 77,
      height: 69,
      popupIconWidth: 58,
    },

    {
      id: 1,
      image: AppImages.icBronzeBelt,
      title: "Bronze",
      isSelected: true,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: false,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      image: AppImages.icSilverBelt,
      title: "Silver",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      image: AppImages.icGoldBelt,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 4,
      image: AppImages.icPlatinumBelt,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  const [saleBeltModal, setSaleBeltModal] = useState(false);
  const [isNegotiating, setIsNegotiating] = useState(false);
  const navigation = useNavigation();
  const styles = useNotificationDetailsPopupStyles();
  const { userData } = useUserData();
  const { sendNotification, setUpdateNotification, showChallengeActionPopup } =
    useNotifications();
  const [platformStatus, setPlatformStatus] = useState({
    YouTube: "Not connected",
    Twitch: "Not connected",
  });
  const screenWidth = Dimensions.get("window").width;

  const fetchStatus = async () => {
    try {
      const response = await fetchUserConnectionStatus(accessToken);
      if (response.statusCode === 200) {
        setPlatformStatus(response.body);
      } else {
        toast.error("Failed to fetch platform connection status.");
      }
    } catch (error) {
      console.error("Error fetching platform status:", error);
      toast.error("Failed to fetch platform connection status.");
    }
  };

  const fetchUserProfileData = useCallback(async () => {
    try {
      const response = await fetch(`${base_url}${endpoints.auth.userProfile}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken }),
      });

      const data = await response.json();
      if (response.status === 200) {
        setProfileData(data.body);
      } else {
        toast.error("Failed to fetch user profile data");
      }
    } catch (error) {
      toast.error("Failed to fetch user profile data");
    }
  }, [accessToken]);

  useEffect(() => {
    if (challengeID && showModal) {
      callGetChallengeDetails(challengeID);
    }
  }, [challengeID, showModal]);

  useEffect(() => {
    fetchUserProfileData();
  }, [fetchUserProfileData]);

  useEffect(() => {
    if (showModal) {
      const action = getStoredEventShareAction();
      if (action) {
        setStoredAction(action);
      }
    }
  }, [showModal]);

  // Check user's token balance for accept actions
  const checkUserTokenBalance = useCallback(async () => {
    try {
      const response = await fetchUserBalance(accessToken);
      if (response && response.body) {
        const balance = response.body.koCoins || 0;
        setUserTokenBalance(balance);

        // Get challenge stake amount
        const stakeAmount = challengeDetails?.eventDetails?.stake || 0;

        if (balance < stakeAmount) {
          console.log(
            "💰 Insufficient tokens for accept action. Balance:",
            balance,
            "Required:",
            stakeAmount
          );
          // Show buy tokens message - this will be handled in the UI
        } else {
          console.log("✅ User has sufficient tokens for accept action");
        }
      }
    } catch (error) {
      console.error("❌ Error checking token balance:", error);
      toast.error("Error checking token balance");
    }
  }, [accessToken, challengeDetails]);

  useEffect(() => {
    if (storedAction && !showCreateLoader && challengeDetails) {
      const handleStoredAction = async (action) => {
        try {
          switch (action) {
            case "accept":
              await checkUserTokenBalance();
              break;
            case "reject":
              setTimeout(() => {
                handleAcceptPress(false);
              }, 1000);
              break;
            case "negotiate":
              setTimeout(() => {
                handleNegotiateTerms();
              }, 1000);
              break;
          }

          clearStoredEventShareAction();
        } catch (error) {
          toast.error("Error processing your previous action");
        }
      };

      handleStoredAction(storedAction);
      setStoredAction(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storedAction, showCreateLoader, challengeDetails?.eventDetails?.eventID]);

  const onCloseClick = () => {
    setShowModal(false);
  };

  const IsPrivateEvent =
    challengeDetails?.eventDetails?.eventType === "Exclusive";

  const handleChatRedirect = () => {
    if (username) {
      const queryParams = {
        username: challengeDetails?.eventDetails?.organiserId,
        type: "single",
      };
      const encodedParams = Base64.encode(JSON.stringify(queryParams));
      setShowModal(false);
      navigateToScreen(navigation, AppScreens.Chat, {
        session: encodedParams,
        key: `Chat-${new Date().getTime()}`,
      });
    }
  };

  // Handle chat redirect for stored negotiate actions with auto-return to home
  const handleChatRedirectWithAutoReturn = () => {
    if (username) {
      const queryParams = {
        username: challengeDetails?.eventDetails?.organiserId,
        type: "single",
      };
      const encodedParams = Base64.encode(JSON.stringify(queryParams));
      setShowModal(false);

      // Navigate to chat first
      navigateToScreen(navigation, AppScreens.Chat, {
        session: encodedParams,
        key: `Chat-${new Date().getTime()}`,
      });

      // Wait 3 seconds, then automatically redirect to home page
      setTimeout(() => {
        console.log(
          "🏠 Auto-redirecting to home page after negotiate chat session..."
        );
        navigation.dispatch(StackActions.replace(AppScreens.HomeWebScreen));
      }, 3000);
    }
  };

  const handleNegotiateTerms = async () => {
    // Check if user is logged in
    if (!userData || !userData.AccessToken) {
      toast.info("Please log in to negotiate terms");
      storeEventShareAction("negotiate");
      setShowModal(false);
      navigation.dispatch(StackActions.replace(AppScreens.LoginScreen));
      return;
    }

    setIsNegotiating(true);

    try {
      const response = await fetch(
        `${base_url}${endpoints.events.negotiateTerms}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.AccessToken}`,
          },
          body: JSON.stringify({
            accessToken: userData.AccessToken,
            eventId: challengeDetails?.eventDetails?.eventID,
            newOpponentId: userData.username || userData.userID,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Check if response has message indicating success
        if (data.message || data.chatId) {
          toast.success("Terms negotiated successfully");

          // Track activity FIRST before redirect (fire and forget)
          storeUserActivity(
            accessToken,
            challengeDetails?.eventDetails?.eventID,
            ACTIVITY_TYPES.NEGOTIATION_STARTED
          ).catch((err) => console.warn("Failed to track activity:", err));

          setShowModal(false);

          // Navigate to OnGoingEvents with Chat tab
          navigation.dispatch(
            StackActions.replace(AppScreens.OnGoingEvents, {
              eventID: challengeDetails?.eventDetails?.eventID,
              tab: "Chat",
            })
          );
        } else {
          const errorMessage = data.error || "Failed to negotiate terms";
          toast.error(errorMessage);
        }
      } else {
        const errorMessage = data.error || "Failed to negotiate terms";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error negotiating terms:", error);
      toast.error("Failed to negotiate terms. Please try again.");
    } finally {
      setIsNegotiating(false);
    }
  };

  const callGetChallengeDetails = async (notificationId) => {
    setCreateShowLoader(true);

    try {
      const response = await getNotificationById(accessToken, notificationId);
      if (response.statusCode === 200) {
        setChallengeDetails(response.body.notification);
      } else {
        toast.error("Failed to fetch challenge details");
      }
    } catch (error) {
      toast.error("Failed to fetch challenge details");
      onCloseClick();
    } finally {
      setCreateShowLoader(false);
    }
  };

  const handleAcceptPress = async (userResponse) => {
    setAcceptLoader(true);
    const url = `${base_url}${endpoints.events.challengeRespond}`;

    try {
      const response = await fetch(url, {
        mode: "cors",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          accessToken,
          notificationId: challengeID,
          response: userResponse,
        }),
      });

      const data = await response.json();
      console.log("data", data);

      if (response.status === 200) {
        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.success(
            userResponse
              ? "Challenge Accepted Successfully"
              : "Challenge Rejected Successfully"
          );

          const { body } = data;
          // Parse the body if it's a string (API returns JSON string)
          const parsedBody = typeof body === "string" ? JSON.parse(body) : body;
          const { notificationId, senderId } = parsedBody;

          // Only call onAcceptPress for accept actions, not reject
          if (userResponse) {
            onAcceptPress(userResponse);
          }

          // Track challenge_accepted or challenge_rejected activity
          const activityType = userResponse
            ? ACTIVITY_TYPES.CHALLENGE_ACCEPTED
            : ACTIVITY_TYPES.CHALLENGE_REJECTED;
          const eventId = challengeDetails?.eventDetails?.eventID;
          if (eventId) {
            storeUserActivity(accessToken, eventId, activityType)
              .then((result) => {
                if (result.success) {
                  console.log(`✅ ${activityType} activity tracked:`, result.activityId);
                }
              })
              .catch((err) => console.warn(`⚠️ Error tracking ${activityType}:`, err));
          }

          const updateResponse = {
            challengeId: challengeID,
            response: userResponse,
          };

          setUpdateNotification(updateResponse);

          await sendNotification(senderId, notificationId);

          if (userResponse) {
            await fetchStatus();
            setShowAcceptModal(true);
            handleProfileUpdate();
          } else {
            // For reject, close modal and show popup via context
            setShowModal(false);

            // Show the Challenge Rejected popup (no auto-redirect, user must close manually)
            setTimeout(() => {
              //@ts-ignore
              showChallengeActionPopup("reject", false);
            }, 500);
          }
        } else if (data.statusCode === 400) {
          console.log("Insufficient stakes error:", data);

          // Parse the error message to extract required stakes
          let errorMessage = "";
          if (data.body && typeof data.body === "object" && data.body.error) {
            errorMessage = data.body.error;
          } else if (typeof data.body === "string") {
            try {
              const parsedBody = JSON.parse(data.body);
              errorMessage = parsedBody.error || "";
            } catch (e) {
              errorMessage = data.body;
            }
          }

          // Extract required belts from error message
          // Example: "Insufficient stakes. Required: 20 Bronze"
          const match = errorMessage.match(/Required:\s*(\d+)\s*(\w+)/i);
          if (match) {
            const requiredAmount = parseInt(match[1]);
            const beltType = match[2];

            setInsufficientStakesError({
              requiredAmount,
              beltType,
              fullMessage: errorMessage,
            });

            // Calculate how many belts the user needs to buy
            const userBronzeBelts =
              arrBeltMedalType.find((b) => b.title === "Bronze")?.value || 0;
            const beltsToBuy = Math.max(0, requiredAmount - userBronzeBelts);
            setNumberOfBelts(beltsToBuy.toString());
          } else {
            setInsufficientStakesError({
              fullMessage: errorMessage,
            });
          }

          setCornfirmPurchaseBeltModal(true);
        } else {
          try {
            const parsedData = JSON.parse(data.body);
            toast.error(parsedData.message || "An error occurred");
          } catch (error) {
            toast.error(data.body);
          }
        }
      } else {
        toast.error("Failed to respond to challenge");
      }
    } catch (error) {
      toast.error("Failed to respond to challenge");
    } finally {
      setAcceptLoader(false);
    }
  };

  const handleProfileUpdate = async () => {
    if (!profileData) {
      toast.error("Profile data not loaded");
      return;
    }

    const updatedPlayGames = [
      ...(profileData?.playedGames || []),
      {
        eventId: challengeDetails?.eventDetails?.eventID,
        gameTitle: challengeDetails?.eventDetails?.gameTitle,
      },
    ];
    const updatedChallenged = [
      ...(profileData?.challenged || []),
      {
        eventId: challengeDetails?.eventDetails?.eventID,
        gameTitle: challengeDetails?.eventDetails?.gameTitle,
      },
    ];

    const params = {
      username,
      accessToken,
      challenged: updatedChallenged,
    };

    try {
      const response = await fetch(
        `${base_url}${endpoints.auth.updateProfile}`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ body: params }),
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        toast.success("User profile updated successfully");
      } else {
        toast.error(data.body.error);
      }
    } catch (error) {
      toast.error("Failed to update user profile");
    }
  };
  const beltData = (challengeDetails?.eventDetails?.stakes ?? [])
    .filter((stake) => stake.quantity > 0) // Only include stakes with quantity > 0
    .map((stake) => {
      let beltImage;
      let beltText;

      switch (stake.type) {
        case "Token":
          beltImage = AppImages.icCoinBelt;
          beltText = "Token";
          break;
        case "Bronze":
          beltImage = AppImages.icBronzeBelt;
          beltText = "Bronze";
          break;
        case "Silver":
          beltImage = AppImages.icSilverBelt;
          beltText = "Silver";
          break;
        case "Gold":
          beltImage = AppImages.icGoldBelt;
          beltText = "Gold";
          break;
        case "Platinum":
          beltImage = AppImages.icPlatinumBelt;
          beltText = "Platinum";
          break;
        default:
          beltImage = AppImages.icCoinBelt;
          beltText = "Token";
      }

      return {
        beltImage,
        beltText,
        amount: stake.quantity,
      };
    });

  const TitleDetailView = ({ title, description }) => (
    <View style={styles.titleDetailWrapper}>
      <Text style={styles.titleText}>{title}</Text>
      <Text style={styles.descriptionText}>{description}</Text>
    </View>
  );

  // Use imported formatDate from utility/Index
  const calculateProgress = (won, total) => {
    if (total === 0) return 0;
    return won / total; // Returns a fraction for the progress bar
  };
  const checkUserBalanceAPI = async () => {
    try {
      const data = await fetchUserBalance(accessToken);

      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      if (data) {
        setUserBalanceData(responseBody);
        const belts = responseBody?.belts;

        const arr = [...arrBeltMedalType];

        // Only process belts if they exist
        if (belts) {
          arr.map((item) => {
            if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
            else if (item.title === "Silver")
              item.value = Number(belts.silver || 0);
            else if (item.title === "Gold")
              item.value = Number(belts.gold || 0);
            else if (item.title === "Platinum")
              item.value = Number(belts.platinum || 0);
          });
        }
        setArrBeltMedalType(arr);
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const paymentBeltExchangeAPI = async () => {
    try {
      const response = await fetchPaymentBeltExchange(accessToken);
      if (response.statusCode === 200) {
        const arr = [...arrBeltMedalType];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = Number(response.exchangeRates.bronze);
            item.sellPrice = Number(response.sellRates.bronze);
          } else if (item.title === "Silver") {
            item.currentPrize = Number(response.exchangeRates.silver);
            item.sellPrice = Number(response.sellRates.silver);
          } else if (item.title === "Gold") {
            item.currentPrize = Number(response.exchangeRates.gold);
            item.sellPrice = Number(response.sellRates.gold);
          } else if (item.title === "Platinum") {
            item.currentPrize = Number(response.exchangeRates.platinum);
            item.sellPrice = Number(response.sellRates.platinum);
          }
        });
        setArrBeltMedalType(arr);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    checkUserBalanceAPI();
    paymentBeltExchangeAPI();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View style={styles.header}>
            {showCreateLoader ? (
              <NotificationHeaderSkeleton />
            ) : (
              <>
                <View
                  style={{
                    display: "flex",
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",
                    gap: 20,
                  }}
                >
                  <Image
                    source={AppImages.icNotificationLogo}
                    style={{ height: 75, width: 110 }}
                    resizeMode="contain"
                  />
                  {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                    <Image
                      source={AppImages.icNotificationBarcode}
                      style={{ height: 50, width: 425, marginTop: 15 }}
                    />
                  ) : null}
                  {deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM ? null : IsPrivateEvent ? (
                      <Image
                        source={AppImages.icExclusiveEvent}
                        style={{
                          width: 72,
                          height: 72,
                        }}
                        resizeMode="contain"
                      />
                    ) : null}
                </View>
                <TouchableOpacity onPress={onCloseClick}>
                  <View style={styles.closeIconWrapper}>
                    <Ionicons
                      name="close"
                      size={20}
                      color={AppColors.white}
                      onPress={onCloseClick}
                    />
                  </View>
                </TouchableOpacity>
              </>
            )}
          </View>

          {deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? (
            <Image
              source={AppImages.icNotificationBarcode}
              style={{ height: 35, width: "100%", marginTop: 15 }}
            />
          ) : null}
          <View style={styles.separator} />

          <ScrollView showsVerticalScrollIndicator={false}>
            {showCreateLoader ? (
              <NotificationDetailsRowSkeleton />
            ) : (
              <>
                {/* First Section */}
                <View
                  style={{
                    backgroundColor: AppColors.purple_453B50,
                    display: "flex",
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",

                    justifyContent:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? null
                        : "space-between",
                    alignItems: "center",
                    padding: 10,
                    borderRadius: 10,
                    gap:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 10
                        : null,
                    marginBottom: 10,
                  }}
                >
                  <View
                    style={{
                      backgroundColor: "#302936",
                      padding: 10,
                      borderRadius: 10,
                      position: "relative",
                      overflow: "hidden",
                      // width: 130,
                    }}
                  >
                    {/* Kaller Tag */}
                    <Badge title={"Kaller"} />

                    <Avatar
                      src={
                        challengeDetails?.eventDetails?.organiserProfilePicture
                      }
                      variant="full"
                    />
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 5,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        Game won
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        {
                          challengeDetails?.eventDetails?.participantProfiles[0]
                            ?.gamesWonCount
                        }
                      </Text>
                    </View>
                    <View>
                      <ProgressBar
                        progress={calculateProgress(
                          challengeDetails?.eventDetails?.participantProfiles[0]
                            ?.gamesWonCount,
                          challengeDetails?.eventDetails?.participantProfiles[0]
                            ?.playedGamesCount
                        )}
                        color={AppColors.green_44aeb4}
                        style={{
                          marginTop: 5,
                          height: 8,
                          borderRadius: 3,
                          backgroundColor: AppColors.black,
                        }}
                      />
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 10,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        Played Games
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        {
                          challengeDetails?.eventDetails?.participantProfiles[0]
                            ?.playedGamesCount
                        }
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_16,
                        {
                          color: AppColors.white,
                        },
                      ]}
                    >
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_16,
                          {
                            color: AppColors.white,
                          },
                        ]}
                      >
                        {challengeDetails?.eventDetails?.organiserId} {""}
                      </Text>
                      has challenged you in
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        {
                          color: AppColors.white,
                        },
                      ]}
                    >
                      {challengeDetails?.eventDetails?.gameTitle}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        {
                          color: AppColors.white,
                          marginVertical: 10,
                        },
                      ]}
                    >
                      Will start on:
                    </Text>

                    <View
                      style={{
                        backgroundColor: AppColors.yellow_b69200,
                        borderRadius: 5,
                      }}
                    >
                      <Text
                        style={[
                          deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                            ? AppFontStyle.BOLD_ANYBODY_14
                            : AppFontStyle.BOLD_ANYBODY_16,
                          {
                            color: AppColors.white,
                            padding: 5,
                          },
                        ]}
                      >
                        {formatDate(
                          challengeDetails?.eventDetails?.eventStartTime
                        ) || "Not Specified"}
                      </Text>
                    </View>
                  </View>
                  {IsPrivateEvent ? (
                    <View style={{ gap: 12 }}>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_24,
                          { textAlign: "center" },
                        ]}
                      >
                        Iam beat you
                      </Text>
                      <View style={{ flexDirection: "row", gap: 20 }}>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Event Type
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {challengeDetails?.eventDetails?.eventType ===
                                "Public"
                                ? "Kall-Out"
                                : "Exclusive"}
                            </Text>
                          </View>
                        </View>{" "}
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Play Type
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              1 vs 1
                            </Text>
                          </View>
                        </View>{" "}
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Game
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              Call of duty
                            </Text>
                          </View>
                        </View>
                      </View>
                      <View style={{ flexDirection: "row", gap: 20 }}>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Device
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              Pc
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Gamer id
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              23344DD34
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  ) : (
                    <View
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ImageComponent
                        url={challengeDetails?.eventDetails?.gameImage}
                        style={{
                          width:
                            deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                              ? 123
                              : 115,
                          height:
                            deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                              ? 141
                              : 125,
                          marginTop: 10,
                          borderRadius: 20,
                          resizeMode: "contain",
                        }}
                      />
                    </View>
                  )}
                </View>
                {/* Second Section */}
                <View
                  style={{
                    backgroundColor: AppColors.purple_453B50,
                    padding: 10,
                    borderRadius: 10,
                    marginBottom: 10,
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",
                    gap: 20,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    {/* Belts View */}
                    <View style={{ alignItems: "center" }}>
                      <View style={styles.titleDetailWrapper}>
                        <View style={{ flexDirection: "row", gap: 10 }}>
                          {/* {beltData.map((belt, index) => (
                          <View key={index}>
                            <Image
                              source={belt.beltImage}
                              style={{
                                height: 34,
                                width: 37,
                                alignSelf: "center",
                                resizeMode: "center",
                                marginBottom: 10,
                              }}
                            />
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_14,
                                { marginBottom: 10, alignSelf: "center" },
                              ]}
                            >
                              {belt.amount}
                            </Text>
                            <Text
                              style={[
                                AppFontStyle.REGULAR_ANYBODY_10,
                                { marginBottom: 10, alignSelf: "center" },
                              ]}
                            >
                              {belt.beltText}
                            </Text>
                          </View>
                        ))} */}
                          {beltData.map((belt, index) => (
                            // <View
                            //   key={index}
                            //   style={[
                            //     styles.beltCard,
                            //     // { backgroundColor: belt.backgroundColor },
                            //   ]}
                            // >
                            <View
                              key={index}
                              style={{
                                width: 145,
                                alignItems: "center",
                              }}
                            >
                              <View
                                style={{
                                  width:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 100
                                      : 106,
                                  height:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 50
                                      : 50,
                                  borderRadius: 5,
                                  borderColor: AppColors.black_161719,
                                  backgroundColor:
                                    belt.beltText === "Bronze"
                                      ? "#99633D"
                                      : belt.beltText === "Silver"
                                        ? "#9FA3A3"
                                        : belt.beltText === "Gold"
                                          ? "#DDBE6F"
                                          : belt.beltText === "Platinum"
                                            ? "#FAFFFE"
                                            : "transparent",
                                  borderWidth: 1,
                                  justifyContent: "center",
                                  alignItems: "flex-end",
                                  paddingRight: 10,
                                }}
                              >
                                <Image
                                  source={belt.beltImage}
                                  style={styles.beltImage}
                                  resizeMode="contain"
                                />
                                <View style={styles.numberContainer}>
                                  <Text style={AppFontStyle.MEDIUM_ANYBODY_18}>
                                    {belt.amount}
                                  </Text>
                                </View>
                              </View>
                            </View>
                            // </View>
                          ))}
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        gap: 10,
                      }}
                    >
                      <View
                        style={{
                          width:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 170
                              : null,
                        }}
                      >
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.REGULAR_ANYBODY_14
                              : AppFontStyle.REGULAR_ANYBODY_16,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Accept the challenge to earn:{" "}
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? AppFontStyle.BOLD_ANYBODY_16
                                : AppFontStyle.BOLD_ANYBODY_18,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {challengeDetails?.eventDetails?.totalCredits}{" "}
                            credits
                          </Text>
                        </Text>
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.BOLD_ANYBODY_16
                              : AppFontStyle.BOLD_ANYBODY_18,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          worth
                        </Text>
                      </View>
                      <View
                        style={{
                          backgroundColor: AppColors.black,
                          alignItems: "center",
                          justifyContent: "center",
                          height: 50,
                          width: 100,
                          borderRadius: 5,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_16,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          £{challengeDetails?.eventDetails?.totalBalance}
                        </Text>
                      </View>
                    </View>
                  </View>
                  {IsPrivateEvent ? (
                    <View style={{ gap: 3, alignItems: "center" }}>
                      <Image
                        source={AppImages.icExclusiveEvent}
                        style={{
                          width: 141,
                          height: 141,
                        }}
                        resizeMode="contain"
                      />
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_14,
                          {
                            textAlign: "center",
                            color: AppColors.yellow_FBEBBC,
                          },
                        ]}
                      >
                        Exclusive Event
                      </Text>
                    </View>
                  ) : null}
                  {IsPrivateEvent && showDetails ? (
                    <View
                      style={{
                        justifyContent: "space-between",
                        gap: 20,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 20,
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                          Cost of stream
                        </Text>
                        <View
                          style={{
                            padding: 10,
                            borderRadius: 10,
                            backgroundColor: AppColors.black_18151b,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              { fontWeight: 800 },
                            ]}
                          >
                            $
                            <Text style={[AppFontStyle.BOLD_ANYBODY_20, {}]}>
                              2.00
                            </Text>
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 20,
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                          Set Ticket Price
                        </Text>
                        <View
                          style={{
                            padding: 10,
                            borderRadius: 10,
                            backgroundColor: AppColors.black_18151b,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_26,
                              { fontWeight: 800 },
                            ]}
                          >
                            $
                            <Text style={[AppFontStyle.BOLD_ANYBODY_22, {}]}>
                              13
                            </Text>
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 12,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          Ticket refund policy
                        </Text>
                        <TouchableOpacity>
                          <Image
                            source={AppImages.icInfoCircle}
                            style={{
                              height:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 17
                                  : 20,
                              width:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 17
                                  : 20,
                              resizeMode: "contain",
                            }}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                  ) : null}
                </View>
                {IsPrivateEvent && !showDetails ? (
                  <View
                    style={{
                      backgroundColor: AppColors.purple_453B50,
                      padding: 10,
                      borderRadius: 10,
                      marginBottom: 10,
                      flexDirection: "row",
                      gap: 20,
                    }}
                  >
                    <Text style={[AppFontStyle.MEDIUM_ANYBODY_14]}>
                      By accepting, I agree to the{" "}
                      <TouchableOpacity
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: AppColors.white,
                        }}
                      >
                        terms and conditions
                      </TouchableOpacity>
                    </Text>
                  </View>
                ) : null}
                {!showDetails && (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                      paddingHorizontal: 5,
                    }}
                  >
                    <TouchableOpacity
                      style={{
                        backgroundColor: AppColors.purple_453B50,
                        borderWidth: 1,
                        borderColor: AppColors.white,
                        borderRadius: 3,
                        padding: 8,
                        flexDirection: "row",
                        gap: 3,
                        alignItems: "center",
                      }}
                      onPress={() => handleNegotiateTerms()}
                      disabled={isNegotiating}
                    >
                      <ImageComponent
                        url={AppImages.icNotificationMessage}
                        style={{
                          width: 20,
                          height: 20,
                        }}
                      />
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.white,
                          },
                        ]}
                      >
                        {isNegotiating ? "Negotiating..." : "Negotiate Terms"}
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.chatButton}
                      onPress={() => setShowDetails(!showDetails)}
                    >
                      <Text style={styles.chatButtonText}>
                        {showDetails
                          ? "Hide Details"
                          : "View challenge Details"}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
                {/* Third Section */}
                {showDetails && (
                  <>
                    {IsPrivateEvent ? (
                      <View
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          display: "flex",
                          flexDirection:
                            deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                              ? "column"
                              : "row",
                          padding: 10,
                          borderRadius: 10,
                          marginBottom: 10,
                          justifyContent: "space-between",
                          ...(deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                            ? { gap: 12 }
                            : {}),
                        }}
                      >
                        <View style={{ gap: 12 }}>
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 12,
                              alignItems: "center",
                            }}
                          >
                            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                              Ticket Sales Earnings Profit Share
                            </Text>
                            <TouchableOpacity>
                              <Image
                                source={AppImages.icInfoCircle}
                                style={{
                                  height:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 17
                                      : 20,
                                  width:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 17
                                      : 20,
                                  resizeMode: "contain",
                                }}
                              />
                            </TouchableOpacity>
                          </View>
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                              Kaller Revenue
                            </Text>
                            <Text style={AppFontStyle.BOLD_ANYBODY_14}>
                              50%
                            </Text>
                          </View>
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                              Challengers Revenue
                            </Text>
                            <Text style={AppFontStyle.BOLD_ANYBODY_14}>
                              50%
                            </Text>
                          </View>
                        </View>
                        <View style={{}}>
                          <ScrollView
                            horizontal={true}
                            showsHorizontalScrollIndicator={false}
                            style={{
                              width: screenWidth - 32,
                            }}
                            contentContainerStyle={{
                              flexDirection: "row",
                              gap: 20,
                              ...(deviceSize === DEVICE_SIZES.XS ||
                                deviceSize === DEVICE_SIZES.SM
                                ? { marginRight: 67 }
                                : {}),
                            }}
                          >
                            <View
                              style={{
                                gap: 3,
                              }}
                            >
                              <Text
                                style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                              >
                                Duration
                              </Text>
                              <View
                                style={{
                                  backgroundColor: AppColors.black,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: 10,
                                  borderRadius: 5,
                                }}
                              >
                                <Text
                                  style={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                                >
                                  1 hour
                                </Text>
                              </View>
                            </View>{" "}
                            <View
                              style={{
                                gap: 3,
                              }}
                            >
                              <Text
                                style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                              >
                                Quality
                              </Text>
                              <View
                                style={{
                                  backgroundColor: AppColors.black,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: 10,
                                  borderRadius: 5,
                                }}
                              >
                                <Text
                                  style={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                                >
                                  High (1080p & 60fps)
                                </Text>
                              </View>
                            </View>
                            <View
                              style={{
                                gap: 3,
                              }}
                            >
                              <Text
                                style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                              >
                                Number of Attendees
                              </Text>
                              <View
                                style={{
                                  backgroundColor: AppColors.black,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: 10,
                                  borderRadius: 5,
                                }}
                              >
                                <Text
                                  style={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                                >
                                  100
                                </Text>
                              </View>
                            </View>{" "}
                            <View
                              style={{
                                gap: 3,
                              }}
                            >
                              <Text
                                style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}
                              >
                                Time limit
                              </Text>
                              <View
                                style={{
                                  backgroundColor: AppColors.black,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: 10,
                                  borderRadius: 5,
                                }}
                              >
                                <Text
                                  style={[
                                    AppFontStyle.BOLD_ANYBODY_14,
                                    {
                                      color: AppColors.white,
                                    },
                                  ]}
                                >
                                  week
                                </Text>
                              </View>
                            </View>
                          </ScrollView>
                        </View>
                      </View>
                    ) : (
                      <View
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          display: "flex",
                          flexDirection: "row",
                          padding: 10,
                          borderRadius: 10,
                          marginBottom: 10,
                          justifyContent: "space-around",
                        }}
                      >
                        <View>
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? AppFontStyle.BOLD_ANYBODY_16
                                : AppFontStyle.BOLD_ANYBODY_18,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Event name:
                          </Text>
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? AppFontStyle.REGULAR_ANYBODY_14
                                : AppFontStyle.REGULAR_ANYBODY_16,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {challengeDetails?.eventDetails?.eventTitle}
                          </Text>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Event Type
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {challengeDetails?.eventDetails?.eventType ===
                                "Public"
                                ? "Kall-Out"
                                : "Exclusive"}
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Play Type
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              1 VS 1
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Game
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {challengeDetails?.eventDetails?.gameTitle}
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Device
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {challengeDetails?.eventDetails?.device}
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Gamer id
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {
                                challengeDetails?.eventDetails?.gamerID
                                  ?.organiser
                              }
                            </Text>
                          </View>
                        </View>
                      </View>
                    )}
                    <View
                      style={{
                        backgroundColor: AppColors.purple_453B50,
                        display: "flex",
                        flexDirection: "row",
                        padding: 10,
                        borderRadius: 10,
                        marginBottom: 10,
                        gap: 5,
                      }}
                    >
                      <View>
                        <ImageComponent
                          url={challengeDetails?.eventDetails?.gameImage}
                          style={{
                            width:
                              deviceSize === DEVICE_SIZES.XS ||
                                deviceSize === DEVICE_SIZES.SM
                                ? 123
                                : 115,
                            height:
                              deviceSize === DEVICE_SIZES.XS ||
                                deviceSize === DEVICE_SIZES.SM
                                ? 141
                                : 125,
                            marginTop: 10,
                            borderRadius: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </View>
                      <View
                        style={{
                          marginTop: 10,
                          gap: 5,
                          width: 575,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Rules & Description:
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          {challengeDetails?.eventDetails?.description}
                        </Text>
                      </View>
                    </View>
                    {IsPrivateEvent ? (
                      <View
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          padding: 10,
                          borderRadius: 10,
                          marginBottom: 10,
                          gap: 10,
                        }}
                      >
                        <Text style={AppFontStyle.SEMIBOLD_ANYBODY_18}>
                          Terms & condition
                        </Text>
                        <Text style={AppFontStyle.REGULAR_ANYBODY_16}>
                          The total cost of the event, including streaming fees,
                          will be deducted from your token balance and held
                          securely until the event goes live.
                        </Text>

                        <Text style={AppFontStyle.REGULAR_ANYBODY_16}>
                          Once the event is listed for the audience, no refunds
                          will be issued unless the minimum attendee requirement
                          is not met. If the minimum number of attendees is not
                          reached by the deadline, the streaming cost will be
                          refunded, and the event can be cancelled or can go
                          live on the agreement of both parties.=
                        </Text>
                      </View>
                    ) : null}

                    {/* Buttons positioned below description when details are shown */}
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 15,
                        paddingHorizontal: 5,
                      }}
                    >
                      <TouchableOpacity
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          borderWidth: 1,
                          borderColor: AppColors.white,
                          borderRadius: 3,
                          padding: 8,
                          flexDirection: "row",
                          gap: 3,
                          alignItems: "center",
                        }}
                        onPress={() => handleNegotiateTerms()}
                        disabled={isNegotiating}
                      >
                        <ImageComponent
                          url={AppImages.icNotificationMessage}
                          style={{
                            width: 20,
                            height: 20,
                          }}
                        />
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          {isNegotiating ? "Negotiating..." : "Negotiate Terms"}
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={styles.chatButton}
                        onPress={() => setShowDetails(!showDetails)}
                      >
                        <Text style={styles.chatButtonText}>Hide Details</Text>
                      </TouchableOpacity>
                    </View>
                  </>
                )}
              </>
            )}

            <View style={styles.separator} />
          </ScrollView>

          <View style={styles.buttonWrapper}>
            {showCreateLoader ? (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Skeletons
                  height={53}
                  width={
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? "129px"
                      : "334px"
                  }
                />
                <Skeletons
                  height={53}
                  width={
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? "129px"
                      : "334px"
                  }
                />
              </View>
            ) : (
              <>
                {/* Show insufficient tokens message for stored accept actions */}
                {(() => {
                  const stakeAmount =
                    challengeDetails?.eventDetails?.stake || 0;
                  const hasInsufficientTokens =
                    storedAction === "accept" && userTokenBalance < stakeAmount;

                  if (hasInsufficientTokens) {
                    return (
                      <View
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          borderRadius: 10,
                          padding: 15,
                          marginBottom: 15,
                          borderWidth: 1,
                          borderColor: AppColors.white,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            {
                              color: AppColors.white,
                              textAlign: "center",
                              marginBottom: 8,
                            },
                          ]}
                        >
                          Note: This challenge requires {stakeAmount} KO tokens
                          to match the challenge stake.
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { color: AppColors.white, textAlign: "center" },
                          ]}
                        >
                          You currently have {userTokenBalance} KO tokens. Add{" "}
                          {stakeAmount - userTokenBalance} KO tokens to lock in
                          your participation.
                        </Text>
                      </View>
                    );
                  }
                  return null;
                })()}

                <TouchableOpacity
                  style={[
                    styles.acceptRejectButtonStyle,
                    {
                      backgroundColor:
                        challengeDetails?.eventDetails?.organiserId ===
                          username ||
                          challengeDetails?.eventDetails?.status === "accepted" ||
                          challengeDetails?.eventDetails?.status === "rejected" ||
                          showAcceptLoader
                          ? AppColors.grayColor_393939
                          : "transparent",
                      opacity:
                        challengeDetails?.eventDetails?.organiserId ===
                          username ||
                          challengeDetails?.eventDetails?.status === "accepted" ||
                          challengeDetails?.eventDetails?.status === "rejected" ||
                          showAcceptLoader
                          ? 0.5
                          : 1,
                      borderWidth:
                        challengeDetails?.eventDetails?.organiserId !==
                        username && 2,
                      borderColor:
                        challengeDetails?.eventDetails?.organiserId !==
                        username && AppColors.red_ED1F24,
                    },
                  ]}
                  onPress={() => handleAcceptPress(false)}
                  disabled={
                    challengeDetails?.eventDetails?.organiserId === username ||
                    challengeDetails?.eventDetails?.status === "accepted" ||
                    challengeDetails?.eventDetails?.status === "rejected"
                  }
                >
                  <Text style={{ color: AppColors.buttonRed_DC2626 }}>
                    Reject
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={[
                    styles.acceptRejectButtonStyle,
                    {
                      backgroundColor: (() => {
                        const stakeAmount =
                          challengeDetails?.eventDetails?.stake || 0;
                        const hasInsufficientTokens =
                          storedAction === "accept" &&
                          userTokenBalance < stakeAmount;

                        if (
                          challengeDetails?.eventDetails?.organiserId ===
                          username ||
                          challengeDetails?.eventDetails?.status ===
                          "accepted" ||
                          challengeDetails?.eventDetails?.status ===
                          "rejected" ||
                          showAcceptLoader
                        ) {
                          return AppColors.grayColor_393939;
                        } else if (hasInsufficientTokens) {
                          return AppColors.appViolentColor_6D08C3; // Purple for buy tokens
                        } else {
                          return AppColors.appGreenColor_51AF07;
                        }
                      })(),
                      opacity:
                        challengeDetails?.eventDetails?.organiserId ===
                          username ||
                          challengeDetails?.eventDetails?.status === "accepted" ||
                          challengeDetails?.eventDetails?.status === "rejected" ||
                          showAcceptLoader
                          ? 0.5
                          : 1,
                    },
                  ]}
                  onPress={() => {
                    // Check if this is from stored accept action and user has insufficient tokens
                    const stakeAmount =
                      challengeDetails?.eventDetails?.stake || 0;
                    const hasInsufficientTokens =
                      storedAction === "accept" &&
                      userTokenBalance < stakeAmount;

                    if (hasInsufficientTokens) {
                      // Show buy tokens modal/action
                      toast.info(
                        `You need ${stakeAmount - userTokenBalance
                        } more KO tokens to accept this challenge`
                      );
                      // TODO: Open buy tokens modal
                    } else {
                      handleAcceptPress(true);
                    }
                  }}
                  disabled={
                    challengeDetails?.eventDetails?.organiserId === username ||
                    challengeDetails?.eventDetails?.status === "accepted" ||
                    challengeDetails?.eventDetails?.status === "rejected"
                  }
                >
                  <Text style={styles.buttonText}>
                    {(() => {
                      const stakeAmount =
                        challengeDetails?.eventDetails?.stake || 0;
                      const hasInsufficientTokens =
                        storedAction === "accept" &&
                        userTokenBalance < stakeAmount;

                      if (hasInsufficientTokens) {
                        return "Buy KO tokens";
                      } else {
                        return "Accept";
                      }
                    })()}
                  </Text>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
        {showAcceptModal && (
          <ChallengeAcceptModal
            eventID={challengeDetails?.eventId}
            showModal={showAcceptModal}
            eventDetails={challengeDetails?.eventDetails}
            setShowModal={setShowAcceptModal}
            setPopup={setShowModal}
            platformStatus={platformStatus}
          />
        )}
        {cornfirmPurchaseBeltModal && (
          <CornfirmPurchaseBeltModal
            accessToken={accessToken}
            numberOfBelts={numberOfBelts}
            setArrBeltMedalType={setArrBeltMedalType}
            arrBeltMedalType={arrBeltMedalType}
            showModal={cornfirmPurchaseBeltModal}
            setRefreshAPICall={setRefreshAPICall}
            userBalanceData={userBalanceData}
            setShowModal={setCornfirmPurchaseBeltModal}
            eventID={challengeDetails?.eventDetails?.eventID || challengeDetails?.EventInfo?.id || challengeID}
            dataSelectedBelt={arrBeltMedalType.find((item) => item.isSelected)}
            insufficientStakesError={insufficientStakesError}
            selectedBelt={(data) => {
              setBeltPurchaseSuccessModal(true);
              setInsufficientStakesError(null); // Clear error after successful purchase
            }}
            jumpToPurchaseToken={(isNavigate: boolean) => {
              if (isNavigate) {
                const eventId = challengeDetails?.eventDetails?.eventID || challengeDetails?.EventInfo?.id;
                // Store pending challenge context for auto-resume after payment
                storePendingChallengeAccept(challengeID, eventId);
                navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                  eventID: eventId,
                  type: "notification",
                });
                setShowModal(false);
              }
            }}
          />
        )}
        {/* BeltPurchaseSuccessModal  */}
        {beltPurchaseSuccessModal && (
          <BeltPurchaseSuccessModal
            setSaleBeltModal={setSaleBeltModal}
            arrBeltMedalType={arrBeltMedalType}
            showModal={beltPurchaseSuccessModal}
            setShowModal={setBeltPurchaseSuccessModal}
            numberOfBelts={numberOfBelts}
            dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
          // backProfileTapped={() => {
          //   reloadAPIs();
          // }}
          />
        )}

        {showAcceptLoader && <ShowLoader showIndicater={showAcceptLoader} />}
      </View>
    </Modal>
  );
}

export default withErrorBoundary(NotificationDetails);
